import SpisStaerkt from './SpisStaerkt';

export default function App() {
  return <SpisStaerkt />;
}